import { inject, Injectable } from '@angular/core';
import { ApiGateway } from '@sb/shared/api';
import { Observable } from 'rxjs';

import { ChartPayload, ChartScheduleResponse, ChartTurnoverResponse, ChartTurnoverSummaryResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ChartApiService {
  private apiGateway = inject(ApiGateway);

  private endpoint = 'charts';

  turnoverSummary(payload: ChartPayload): Observable<ChartTurnoverSummaryResponse> {
    return this.apiGateway.post(`${this.endpoint}/turnover_summary`, payload);
  }

  turnover(payload: ChartPayload): Observable<ChartTurnoverResponse> {
    return this.apiGateway.post(`${this.endpoint}/turnover`, payload);
  }

  schedule(payload: ChartPayload): Observable<ChartScheduleResponse> {
    return this.apiGateway.post(`${this.endpoint}/schedule_timesheet`, payload);
  }
}
